import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const MiningScreen: React.FC = () => {
	return (
		<>
			<Row
				flexible
				mainAxisAlignment="center"
				crossAxisAlignment="center"
				className="relative py-14 max-md:px-5 md:py-36 bg-cover bg-[url('https://www.aulados.net/Temas_ambientales/Aguas_contaminacion_Chile/Serena_Panulcillo_drenaje_acido_1.jpg')] bg-center"
				responsiveCol
			>
				<div className="absolute bg-black/40 top-0 left-0 w-full h-full" />
				<Column
					className="w-full z-[1]"
					data-sal="zoom-out"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="extraBig"
						className="font-title max-md:text-4xl text-center !leading-none text-white"
					>
						Contaminación <br /> Minera
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<img
					className="md:w-2/5 h-60 object-contain rounded-lg max-md:order-last"
					src="https://es-static.z-dn.net/files/d33/10f3902221a2e3ca4bb6a7e060d530c5.jpg"
					alt="representacion de la bioacomulacion"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-left"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						La Bioacumulación
					</TextComponent>
					<TextComponent variant="h5">
						La zona marina costera del distrito de <span className="text-cyan-600 font-bold">Ite, Tacna, Perú</span>, presenta los efectos del{" "}
						<span className="font-semibold text-red-600">pasivo minero</span> por la presencia de
						<span className="font-semibold">metales pesados</span>. Se encontró una gran cantidad de concentraciones de
						<span className="text-yellow-600 font-bold">cadmio (Cd), mercurio (Hg), plomo (Pb), arsénico (As) y zinc (Zn)</span> en{" "}
						<span className="font-semibold">Caballa, Jurel, Pejerrey</span> y moluscos como el <span className="font-semibold">pulpo y la pota</span>.
						<br />
						Todos estos metales pesados encontrados son ingeridos por los peces y <span className="font-semibold text-red-600">no lo logran desechar</span>, por lo que
						<span className="text-red-600 font-bold">permanece en su cuerpo toda su vida</span>, y si son consumidos afectan directamente la{" "}
						<span className="text-green-600 font-bold">salud del ser humano</span>.
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-right"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Los sedimentos tóxicos
					</TextComponent>
					<TextComponent variant="h5">
						Estos <span className="font-semibold text-red-600">destruyen el hábitat</span> y cubren fondos marinos,{" "}
						<span className="font-semibold text-red-600">sofocando a especies bentónicas</span> (como estrellas de mar y crustáceos). El{" "}
						<span className="font-semibold text-red-600">drenaje ácido</span> <span className="text-red-600 font-bold">mata la vegetación marina vital</span> para muchas especies marinas y
						afecta al <span className="text-green-600 font-bold">ser humano</span>.
					</TextComponent>
				</Column>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg"
					src="https://img.freepik.com/fotos-premium/vista-submarina-arrecife-coral-muchos-peces-coloridos-nadando-alrededor-arrecife-esta-lleno-colores-vibrantes-vida_14117-544109.jpg"
					alt="sedimientos toxicos"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Row>
			<Column className="grid grid-cols-1 md:grid-cols-2 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] gap-5 self-center py-10 max-md:px-5">
				<img
					className="rounded-lg border border-gray-400"
					src="/minera-1.png"
					alt="contamiacion por metales 1"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<img
					className="rounded-lg border border-gray-400"
					src="/minera-2.png"
					alt="contamiacion por metales 2"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Column>
		</>
	);
};
